import { render, staticRenderFns } from "./PersonnelDetails.vue?vue&type=template&id=d6c331da&scoped=true&"
import script from "./PersonnelDetails.vue?vue&type=script&lang=js&"
export * from "./PersonnelDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelDetails.vue?vue&type=style&index=0&id=d6c331da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c331da",
  null
  
)

export default component.exports